import { render, staticRenderFns } from "./addInterface.vue?vue&type=template&id=73dc07d0&scoped=true&"
import script from "./addInterface.vue?vue&type=script&lang=js&"
export * from "./addInterface.vue?vue&type=script&lang=js&"
import style0 from "./addInterface.vue?vue&type=style&index=0&id=73dc07d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc07d0",
  null
  
)

component.options.__file = "addInterface.vue"
export default component.exports